module.exports = __webpack_public_path__ + "media/images/pla/pla4-f29fcfc60f3e040f9f2d9e9413af7e50.jpg";